import React from 'react';
import styled from 'styled-components';
import { testId } from '@lojinha/helpers';
import { Text } from '../../../..';
import { t } from '../../helpers/dictionary';
const Container = styled(Text) `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${({ theme }) => theme.space.x16};
  width: ${({ theme }) => theme.space.x48};
`;
const Item = styled.span `
  display: block;
  ${({ theme }) => `
    font-size: ${theme.fontSizes.x1};
    font-weight: ${theme.fontWeights.bold};
    padding: 0 ${theme.space.x8};
  `}
`;
export const Pagination = ({ activePage, totalPagination, }) => {
    const slideIndexActive = activePage + 1;
    return (React.createElement(Container, { "aria-label": t.slideCountLabel(activePage, totalPagination), htmlAttrs: { className: 'carousel-pagination' }, textSize: "x1", isBold: true },
        React.createElement(Item, { ...testId('slide-pagination-actived') }, slideIndexActive),
        "/",
        React.createElement(Item, { ...testId('slide-pagination-total') }, totalPagination)));
};
//# sourceMappingURL=index.js.map